module.exports = __webpack_public_path__ + "img/WIFI-Oesterreich-Trainerin-Diplom.450ec0e4.webp";